<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="align-items-end">
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Arama"
            label-for="search"
            class="mb-md-0"
          >
            <b-form-input
              id="search"
              v-model="searchText"
              placeholder="Başlık ara..."
              @input="onSearchInput"
              @keyup.enter="applyFilters"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Alt Kategori"
            label-for="category"
            class="mb-md-0"
          >
            <v-select
              id="category"
              v-model="filterCategory"
              :options="categoryList"
              label="title"
              :reduce="item => item.id"
              placeholder="Tüm Alt Kategoriler"
              :clearable="true"
              @input="applyFilters"
            >
              <template #option="option">
                <div>{{ option.title }}</div>
                <div v-if="option.product_group">
                  <small class="text-warning">{{ option.product_group }}</small>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="text-md-right mt-1 mt-md-0"
        >
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="clearFilters"
          >
            Temizle
          </b-button>
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'products'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ListButtons,
    vSelect,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      searchText: '',
      filterCategory: null,
      searchDebounce: null,
      isRestoring: false,
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'product_categories',
          label: 'Proje Grubu',
          thClass: 'width-300 text-nowrap',
          tdClass: 'width-300 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          'main_category.title AS product_categories',
        ],
        order_by: [
          'products.ordering', 'ASC',
        ],
        where: {},
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['products/dataList']
    },
    dataCounts() {
      return this.$store.getters['products/dataCounts']
    },
    saveData() {
      return this.$store.getters['products/dataSaveStatus']
    },
    categoryList() {
      return this.$store.getters['productGroups/dataList']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.saveFilters()
      if (!this.isRestoring) {
        this.getDataList()
      }
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getCategories()
    this.restoreFilters()
    this.getDataList()
  },
  beforeDestroy() {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce)
    }
  },
  methods: {
    restoreFilters() {
      const filters = this.$store.getters['products/listFilters']
      this.isRestoring = true
      this.searchText = filters.searchText || ''
      this.filterCategory = filters.filterCategory || null
      this.currentPage = filters.currentPage || 1
      this.dataQuery.where = this.buildWhere()
      this.dataQuery.start = (this.currentPage - 1) * this.perPage
      this.$nextTick(() => {
        this.isRestoring = false
      })
    },
    saveFilters() {
      this.$store.commit('products/SET_LIST_FILTERS', {
        searchText: this.searchText,
        filterCategory: this.filterCategory,
        currentPage: this.currentPage,
      })
    },
    getCategories() {
      this.$store.dispatch('productGroups/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'pc.title AS product_group',
        ],
        where: {
          'product_categories.id_product_categories !=': null,
        },
        order_by: [
          'product_categories.ordering', 'ASC',
        ],
      })
    },
    buildWhere() {
      const where = {}
      if (this.filterCategory) {
        where['products.id_low_product_categories '] = this.filterCategory
      }
      if (this.searchText.trim()) {
        where['products.title LIKE'] = `%${this.searchText.trim()}%`
      }
      return where
    },
    onSearchInput() {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce)
      }
      this.searchDebounce = setTimeout(() => {
        this.applyFilters()
      }, 400)
    },
    applyFilters() {
      this.dataQuery.where = this.buildWhere()
      this.saveFilters()
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.dataQuery.start = 0
      this.getDataList()
    },
    clearFilters() {
      this.searchText = ''
      this.filterCategory = null
      this.applyFilters()
    },
    getDataList() {
      this.$store.dispatch('products/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$store.dispatch('products/removeData', id)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
